import React from 'react';
import './OurTeamSection.css'; // Importe o CSS para este componente

// Importe as imagens dos integrantes da equipe
import enzoImage from '../../assets/enzo.svg';
import heloisaImage from '../../assets/heloisa.svg';
import isadoraImage from '../../assets/isadora.svg';
import luizaImage from '../../assets/luiza.svg';

function OurTeamSection() {
  const teamMembers = [
    {
      image: enzoImage,
      name: 'Enzo Previtale',
      role: 'Dev. Back-End',
    },
    {
      image: heloisaImage,
      name: 'Heloisa Militão',
      role: 'UI/UX - Dev. Front-end',
    },
    {
      image: isadoraImage,
      name: 'Isadora Abreu',
      role: 'Dev. Back-End',
    },
    {
      image: luizaImage,
      name: 'Luiza Gonçalves',
      role: 'Dev. Front-end',
    },
  ];

  return (
    <section id="nossa-equipe" className="our-team-section">
      <div className="container">
        <span className="subtitle">INTEGRANTES</span>
        <h2>Nossa equipe</h2>

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div className="team-member-card" key={index}>
              <img src={member.image} alt={member.name} className="member-photo" />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OurTeamSection;